import React from "react";

/**
 * AngadyaLogo — renders the uploaded logo PNG at the requested size. On dark
 * surfaces (tone="light") the mark is wrapped in a soft rounded light tile so
 * it always reads at high contrast; on light surfaces it renders directly.
 */
export const AngadyaLogo = ({ size = 40, tone = "light", className = "", testId }) => {
  const dark = tone === "light"; // Rendered ON a dark surface — needs a light tile.
  const radius = Math.round(size * 0.24);

  if (dark) {
    return (
      <span
        data-testid={testId}
        className={`inline-flex items-center justify-center shrink-0 ${className}`}
        style={{
          width: size,
          height: size,
          borderRadius: radius,
          background: "linear-gradient(135deg, #FFFFFF 0%, #F5F6FA 100%)",
          boxShadow: "0 6px 14px rgba(0,180,216,0.20), 0 2px 4px rgba(20,20,43,0.15), inset 0 0 0 1px rgba(255,255,255,0.6)",
          padding: Math.round(size * 0.10),
        }}
        aria-label="Angadya"
      >
        <img
          src="/logo.png"
          alt="Angadya"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            display: "block",
          }}
        />
      </span>
    );
  }
  return (
    <img
      src="/logo.png"
      alt="Angadya"
      data-testid={testId}
      className={className}
      style={{
        width: size,
        height: size,
        objectFit: "contain",
      }}
    />
  );
};

export default AngadyaLogo;
